module.exports = __webpack_public_path__ + "img/shirt.35980378.svg";